import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Form } from 'react-router-dom';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export default function PreferencesInputFileUpload() {
    return (
        <Form method="post" encType="multipart/form-data">
            <Button
                fullWidth
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                sx={{ mb: 1 }}
                startIcon={<CloudUploadIcon />}

            >
                Dosya Seç
                <VisuallyHiddenInput
                    type="file"
                    name='file'
                    accept=".xlsx"
                    required
                />
            </Button>
            <Button type='submit' fullWidth color="success" variant='contained'>
                Gönder
            </Button>
        </Form>
    );
}
